import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import {
  ONBOARDING_SHEET_CLOSE_MS,
  ONBOARDING_SHEET_EXIT_EVENT,
} from "./onboardingSheetConstants";
import "./OnboardingSheet.css";

export default function OnboardingExitLayer() {
  const [active, setActive] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    let closeTimer = 0;
    let doneTimer = 0;

    const onExit = () => {
      if (closeTimer) window.clearTimeout(closeTimer);
      if (doneTimer) window.clearTimeout(doneTimer);

      setActive(true);
      setClosing(false);

      closeTimer = window.setTimeout(() => {
        setClosing(true);
      }, 20);

      doneTimer = window.setTimeout(() => {
        setActive(false);
        setClosing(false);
      }, ONBOARDING_SHEET_CLOSE_MS);
    };

    window.addEventListener(ONBOARDING_SHEET_EXIT_EVENT, onExit);
    return () => {
      window.removeEventListener(ONBOARDING_SHEET_EXIT_EVENT, onExit);
      if (closeTimer) window.clearTimeout(closeTimer);
      if (doneTimer) window.clearTimeout(doneTimer);
    };
  }, []);

  if (!active) return null;

  const rootClass = [
    "onboarding-sheet-root",
    "onboarding-sheet-root--exit-overlay",
    closing ? "onboarding-sheet-root--closing" : "onboarding-sheet-root--open",
  ].join(" ");

  return createPortal(
    <div className={rootClass} role="presentation" aria-hidden>
      <div className="onboarding-sheet-backdrop" />
    </div>,
    document.body,
  );
}
